import { render } from "./ConfirmationView.vue?vue&type=template&id=097d12ad&scoped=true"
import script from "./ConfirmationView.vue?vue&type=script&lang=js"
export * from "./ConfirmationView.vue?vue&type=script&lang=js"

import "./ConfirmationView.vue?vue&type=style&index=0&id=097d12ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097d12ad"]])

export default __exports__